import type { GateShape } from '../core/chart';
import type { Verdict } from '../core/types';

export const PAPER = 0xf7efe2;
export const INK = 0x2e2433;
export const SHADOW = 0xe6d7c1;
export const PEACH = 0xffb59e;
export const CORAL = 0xf48f7f;
export const MINT = 0x9fe0c4;
export const BUTTER = 0xffdf8a;
export const LILAC = 0xc9b3e6;
export const SKY = 0x9ccdf2;
export const STONE = 0xc4b8aa;

export const HELD_COLOR = PEACH;

export const SHAPE_COLORS: Readonly<Record<GateShape, number>> = {
  circle: SKY,
  square: LILAC,
  triangle: BUTTER,
  hex: MINT,
};

export const VERDICT_COLORS: Readonly<Record<Verdict, number>> = {
  perfect: MINT,
  good: SKY,
  weak: BUTTER,
  flop: CORAL,
  miss: STONE,
};

export function lerpColor(a: number, b: number, t: number): number {
  const k = Math.max(0, Math.min(1, Number.isFinite(t) ? t : 0));
  const mix = (shift: number): number => {
    const from = (a >> shift) & 0xff;
    const to = (b >> shift) & 0xff;
    return Math.round(from + (to - from) * k) << shift;
  };
  return mix(16) | mix(8) | mix(0);
}
